const modules = {
	Scene: "Scene",
	Login: "Login",
	Introduction: "Introduction",
	Checklist: "Checklist",
	ThankYou: "ThankYou",
}

const loadedModules = {}

class DynamicModuleLoader {
	/**
	 * get the list of dynamic Modules
	 * @returns object
	 */
	get modules() {
		return modules
	}

	/**
	 * use webpack dynamic imports
	 * @param componentName {string}
	 * @param callback {function}
	 * @private
	 */
	_import(componentName, callback) {
		if (typeof componentName === "string" && typeof callback === "function") {
			let modulePromise

			switch (componentName) {
				case modules.Scene:
					modulePromise = import(/* webpackChunkName: "Scene" */ "../components/Scene")
					break
				case modules.Login:
					modulePromise = import(/* webpackChunkName: "Login" */ "../components/Login")
					break
				case modules.Introduction:
					modulePromise = import(/* webpackChunkName: "Introduction" */ "../components/Introduction")
					break
				case modules.Checklist:
					modulePromise = import(/* webpackChunkName: "Checklist" */ "../components/Checklist")
					break
				case modules.ThankYou:
					modulePromise = import(/* webpackChunkName: "ThankYou" */ "../components/ThankYou")
					break
				default:
					// eslint-disable-next-line no-console
					console.warn("Module not found")
					break
			}

			modulePromise.then((component) => {
				callback(component.default)
			})
		}
	}

	/**
	 * Dynamically Module Loader
	 * @param condition {boolean}
	 * @param componentName {string}
	 * @param onLoadComponent {function}
	 */
	load(condition, componentName, onLoadComponent = undefined) {
		if (condition) {
			if (!loadedModules[componentName]) {
				this._import(componentName, (Component) => {
					if (typeof onLoadComponent === "function") {
						onLoadComponent(Component)
					} else {
						new Component()
					}
					loadedModules[componentName] = Component
				})
			} else {
				if (typeof onLoadComponent === "function") {
					onLoadComponent(loadedModules[componentName])
				}
			}
		}
	}
}

export default new DynamicModuleLoader()
